import Fetcher from '../fetcher';
import { DEFAULT_POST_INIT, isJsonResponse } from "../fetcher/utils";
import SearchParams from "../init/searchparams";


const $fetcher = Fetcher.many.init(DEFAULT_POST_INIT);
const LOGGING_API_ENDPOINT = `${process.env.API_BASE_URL}/v3/checkout/non-translated-messages`;


export default function logNonTranslatedErrors(payload) {
    let attempts = 0;
    let timelapse = 0;
    const maxAttempts = 5;

    const public_key = SearchParams.get('PBFPubKey');
    const payloadData = JSON.stringify(
        {
            channel: 'Checkout',
            public_key,
            ...payload
        }
    )

    return (function __log__() {
        return (attempts < maxAttempts) && setTimeout(() => {
            return $fetcher(LOGGING_API_ENDPOINT, { body: payloadData })
                .then(response => {
                    if (isJsonResponse(response)) {
                        return response.json()
                            .then(response => {
                                const errorMsg = "Message has already been logged";
                                if (response.status === 'error' && response.message === errorMsg) {
                                    attempts = 5;
                                }
                            })
                    } else {
                        return Promise.reject();
                    }
                })
                .catch(__log__);
          }, (timelapse += attempts++) * 1000);
    })();
}